import { getApiClient } from "@src/api";
import { whiteboardQueryKeys } from "@src/components/board/queries/query-keys";
import { graphql } from "@src/gql/gql";
import { queryClient } from "@src/query-client";
import { useMutation } from "@tanstack/react-query";
import type { Whiteboard } from "../schema";

const openIntakeQuery = graphql(/* GraphQL */ `
	mutation openIntake($whiteboardId: String!) {
		whiteboards {
			openIntake(whiteboardId: $whiteboardId) {
				intakeKey
				isActive
			}
		}
	}
`);

export const useOpenIntake = () => {
	const client = getApiClient();

	return useMutation({
		mutationFn: async (whiteboardId: string) => {
			const result = await client.mutate({
				mutation: openIntakeQuery,
				variables: {
					whiteboardId,
				},
			});

			if (result.errors && result.errors.length > 0) {
				throw new Error(result.errors[0].message);
			}

			return result.data;
		},
		onSuccess: (data, whiteboardId) => {
			const queryData = queryClient.getQueryData<Whiteboard>(
				whiteboardQueryKeys.ofId(whiteboardId),
			);

			const intakeKey = data?.whiteboards?.openIntake?.intakeKey ?? null;

			if (queryData) {
				queryClient.setQueryData(whiteboardQueryKeys.ofId(whiteboardId), {
					...queryData,
					intake: {
						isOpen: true,
						key: intakeKey,
					},
				});
			}
		},
	});
};
